// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"6c947af0","593":"af8e4755","787":"a2448e24"}[chunkId] + ".chunk.js";
};